<template>
  <AuthPage />
</template>

<script>
import AuthPage from "../components/Auth/Home/Home.vue";
export default {
  name: "Auth",
  components: {
    AuthPage,
  },
  mounted() {
    let isLoggedIn = this.$store.getters?.isLoggedIn;
    let userType = this.$store.getters?.userType;

    if (isLoggedIn && userType) {
      this.$router.push(`${userType == "ondemand" ? "/dashboard" : "/3pl/dashboard"}`);
    }
  },
};
</script>

<style></style>
